import { Mail } from "lucide-react";
import { cn } from "@/lib/utils";

export function NewsletterAccessCard({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "rounded-xl border border-accent/25 bg-accent/5 p-5 text-left",
        className,
      )}
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 shrink-0 rounded-lg border border-accent/30 bg-accent/10 p-2 text-accent">
          <Mail className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <h4 className="font-medium text-foreground mb-1">Your newsletter access</h4>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Your Alpha with AI newsletter access is granted to the email on your membership within
            24 hours. Substack will email you when it is live. If it has not arrived by then, write
            to{" "}
            <a
              href="mailto:info@shikshannivesh.com"
              className="text-accent hover:underline"
            >
              info@shikshannivesh.com
            </a>{" "}
            and I will sort it out.
          </p>
        </div>
      </div>
    </div>
  );
}
